import type { UseQueryOptions } from '@tanstack/react-query';
import type { FolderSearchResult } from '../types';
import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import HttpUtils from '~/agent/http-utils';
import { USER_GROUP_SEARCH_API_ROOT } from '../constants';

export function searchUsersAndGroups(term: string): Promise<FolderSearchResult[]> {
  return FetchPromise.get(HttpUtils.buildUriWithQueryString(USER_GROUP_SEARCH_API_ROOT, { term, limit: 5 }));
}

export function useSearchUsersAndGroups(
  term: string,
  queryOptions: UseQueryOptions<FolderSearchResult[], JQuery.jqXHR> = {},
) {
  return useQuery<FolderSearchResult[], JQuery.jqXHR>(
    ['folder_users', term],
    () => searchUsersAndGroups(term),
    queryOptions,
  );
}
